import { Box, Table, Typography } from "@dealer-center/core-components";
import { useGetAutoDataOptions } from "@dealer-center/ddc-pages-vin-decode-fetch";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import type { options5 } from "@dealer-center/ddc-pages-vin-decode-interface";

interface AutoDataOptionsProps {
  vehicleId: string;
}

const columns: TypeSafeTableColumns<options5> = [
  {
    title: "Name",
    dataIndex: "name"
  },
  {
    title: "MSRP",
    dataIndex: "msrPriceStr"
  },
  {
    title: "Invoice Price",
    dataIndex: "invoicePriceStr"
  },
  {
    title: "Extended Description",
    dataIndex: "extendedDescription"
  },
  {
    title: "Code",
    dataIndex: "code"
  },
  {
    title: "Option ID",
    dataIndex: "optionId"
  },
  {
    title: "Included Option IDs",
    dataIndex: "includedOptionIds",
    render: (includedOptionIds: string[]) =>
      includedOptionIds?.join(", ") || "N/A"
  },
  {
    title: "Descriptions",
    dataIndex: "descriptions",
    render: (descriptions: string[]) => descriptions?.join(", ") || "N/A"
  }
];
const pageSize = 10;
export const AutoDataOptions = ({ vehicleId }: AutoDataOptionsProps) => {
  const { data: options, isLoading } = useGetAutoDataOptions(vehicleId);

  return (
    <>
      {isLoading && (
        <LoadingIndicator actionName="VIN Decode Options Loading" />
      )}
      {options?.map(option => (
        <Box key={option.title}>
          {options.length > 1 && (
            <Typography variant="h2">{option.title}</Typography>
          )}
          <Table.Table
            displayFilter
            enablePagination
            sortableColumns
            columns={columns}
            currentPageSize={pageSize}
            data={option.options}
            displayPageSizeSelector={true}
            isLoading={isLoading}
          />
        </Box>
      ))}
    </>
  );
};
